import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { homeBanner } from "../../Assets.tsx";

/* Theme  : same as Our Values.
   Colours: text #4e5356 | buttons #2596be | headings #4573a6
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body)
   Height : fits exactly one screen (100vh), no scrolling needed on desktop. */

const WORDS = ["Accelerate", "Transform", "Scale", "Elevate"];
const MARQUEE = ["Web Development", "Mobile Apps", "E-Commerce", "Web Design", "Digital Marketing", "Full Stack"];

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400&family=Ubuntu:wght@700&display=swap");

.hb {
  --text: #4e5356;
  --head: #4573a6;
  --btn: #2596be;
  --line: #c9dde8;
  --tint: #eef6fa;

  position: relative;
  overflow: hidden;
  height: 100vh;
  min-height: 560px;
  display: flex;
  flex-direction: column;
  padding: 90px 24px 0;
  font-family: "Open Sans", sans-serif;
  font-weight: 400;
  color: var(--text);
  background: #ffffff;
}

.hb::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: none;
}
.hb>*{position:relative;z-index:1}

.hb-main{flex:1;min-height:0;display:grid;grid-template-columns:1.05fr .95fr;align-items:center;gap:50px;max-width:1180px;width:100%;margin:0 auto}

/* ---------- TEXT ---------- */
.hb-text{animation:hbUp .9s cubic-bezier(.2,.8,.2,1) backwards}
.hb-chip{display:inline-flex;align-items:center;gap:10px;margin-bottom:16px;padding:6px 16px;border-radius:50px;background:#fff;border:1px solid var(--line);
  color:var(--head);font-size:12px;letter-spacing:2px;text-transform:uppercase}
.hb-chip i{width:8px;height:8px;border-radius:50%;background:var(--btn);animation:hbPulse 2s infinite}
.hb h1{margin:0 0 14px;font-family:"Ubuntu",sans-serif;font-weight:700;color:var(--head);font-size:clamp(30px,3.7vw,48px);line-height:1.15}
.hb-rot{display:block;height:1.2em;overflow:hidden}
.hb-rot span{display:inline-block;background:linear-gradient(90deg,var(--head),var(--btn));
  -webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;animation:hbWord .6s cubic-bezier(.2,.8,.2,1) backwards}
.hb-sub{margin:0 0 22px;max-width:500px;font-size:15.5px;line-height:1.75;color:var(--text)}

.hb-btns{display:flex;flex-wrap:wrap;gap:12px;margin-bottom:24px}
.hb-btn{position:relative;overflow:hidden;z-index:0;display:inline-flex;align-items:center;gap:10px;padding:12px 28px;border-radius:50px;
  font-family:"Open Sans",sans-serif;font-size:14.5px;cursor:pointer;transition:color .35s,transform .35s cubic-bezier(.3,1.6,.5,1),box-shadow .35s}
.hb-btn::before{content:"";position:absolute;inset:0;z-index:-1;transform:translateX(-101%);transition:transform .45s cubic-bezier(.2,.8,.2,1)}
.hb-btn span{display:inline-block;transition:transform .35s}
.hb-btn:hover{transform:translateY(-3px)}
.hb-btn:hover::before{transform:none}
.hb-btn:hover span{transform:translateX(5px)}
.hb-btn.pri{border:none;background:var(--btn);color:#fff;box-shadow:0 14px 24px -14px rgba(37,150,190,.9)}
.hb-btn.pri::before{background:var(--head)}
.hb-btn.sec{border:2px solid var(--btn);background:transparent;color:var(--btn)}
.hb-btn.sec::before{background:var(--btn)}
.hb-btn.sec:hover{color:#fff}

/* stats */
.hb-stats{display:inline-grid;grid-template-columns:repeat(3,auto);background:#fff;border:1px solid var(--line);border-radius:18px;
  box-shadow:0 16px 30px -24px rgba(69,115,166,.6);overflow:hidden}
.hb-stat{position:relative;padding:12px 22px;transition:background .35s}
.hb-stat + .hb-stat{border-left:1px solid var(--line)}
.hb-stat::after{content:"";position:absolute;left:0;bottom:0;height:3px;width:100%;background:linear-gradient(90deg,var(--head),var(--btn));
  transform:scaleX(0);transform-origin:left;transition:transform .5s cubic-bezier(.2,.8,.2,1)}
.hb-stat:hover{background:var(--tint)}
.hb-stat:hover::after{transform:scaleX(1)}
.hb-stat b{display:block;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:22px;line-height:1.1;color:var(--head)}
.hb-stat small{display:block;margin-top:3px;font-size:12px;color:var(--text)}

/* ---------- VISUAL ---------- */
.hb-visual{position:relative;display:flex;justify-content:center;align-items:center;animation:hbFromR 1s .15s cubic-bezier(.2,.8,.2,1) backwards}
.hb-tilt{position:relative;transition:transform .15s ease-out;transform:perspective(1000px) rotateX(0) rotateY(0)}
.hb-frame{position:relative;overflow:hidden;padding:3px;border-radius:36px;box-shadow:0 34px 60px -34px rgba(69,115,166,.8)}
.hb-frame::before{content:"";position:absolute;left:50%;top:50%;width:200%;height:200%;margin:-100% 0 0 -100%;
  background:conic-gradient(from 0deg,#2596be,#4573a6,#bfe3f1,#2596be);animation:hbSpin 9s linear infinite}
.hb-inner {
  position: relative;
  border-radius: 33px;
  padding: 22px;
  background: #ffffff;
  animation: hbFloat 6s ease-in-out infinite;
}/* image height is limited by the screen height so the banner always fits */
.hb-inner img{display:block;width:auto;max-width:100%;max-height:calc(100vh - 270px);margin:0 auto}

.hb-chipf{position:absolute;z-index:3;display:flex;align-items:center;gap:10px;padding:9px 14px;border-radius:14px;background:rgba(255,255,255,.96);
  border:1px solid var(--line);box-shadow:0 16px 28px -16px rgba(69,115,166,.7);font-size:12px;color:var(--text);white-space:nowrap}
.hb-chipf b{display:block;font-family:"Ubuntu",sans-serif;font-size:15px;color:var(--head);line-height:1.1}
.hb-chipf .ico{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,var(--head),var(--btn))}
.hb-chipf.c1{top:24px;left:-30px;animation:hbFloat 5s ease-in-out infinite}
.hb-chipf.c2{bottom:30px;right:-24px;animation:hbFloat 6s -2s ease-in-out infinite}

/* ---------- MARQUEE ---------- */
.hb-marq{flex:none;width:calc(100% + 48px);margin:0 -24px;overflow:hidden;padding:13px 0;background:linear-gradient(90deg,var(--head),var(--btn))}
.hb-track{display:flex;width:max-content;animation:hbMarq 28s linear infinite}
.hb-marq:hover .hb-track{animation-play-state:paused}
.hb-track span{display:flex;align-items:center;gap:28px;padding-right:28px;color:#fff;font-size:14px;letter-spacing:1.5px;text-transform:uppercase;white-space:nowrap}
.hb-track em{font-style:normal;color:#bfe3f1;font-size:12px}

@keyframes hbUp{from{opacity:0;transform:translateY(50px)}}
@keyframes hbFromR{from{opacity:0;transform:translateX(80px)}}
@keyframes hbWord{from{opacity:0;transform:translateY(70%)}}
@keyframes hbSpin{to{transform:rotate(360deg)}}
@keyframes hbFloat{50%{transform:translateY(-10px)}}
@keyframes hbMarq{to{transform:translateX(-50%)}}
@keyframes hbPulse{0%{box-shadow:0 0 0 0 rgba(37,150,190,.5)}70%{box-shadow:0 0 0 10px rgba(37,150,190,0)}100%{box-shadow:0 0 0 0 rgba(37,150,190,0)}}

/* tablet / mobile: stacked, height becomes automatic */
@media(max-width:960px){
  .hb{height:auto;min-height:0;padding:100px 18px 0}
  .hb-main{grid-template-columns:1fr;gap:44px;padding-bottom:50px}
  .hb-visual{padding:0 14px}
  .hb-inner img{max-height:340px}
  .hb-chipf.c1{left:-6px}.hb-chipf.c2{right:-6px}
  .hb-marq{width:calc(100% + 36px);margin:0 -18px}
}
@media(max-width:520px){
  .hb-stat{padding:12px 14px}.hb-stat b{font-size:19px}
}
@media(prefers-reduced-motion:reduce){
  .hb *,.hb *::before,.hb *::after{animation:none!important;transition:none!important}
}
`;

/* counts from 0 to `to` once on mount */
const useCountUp = (to: number, ms = 1600) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    let raf = 0;
    const t0 = performance.now();
    const tick = (now: number) => {
      const p = Math.min((now - t0) / ms, 1);
      setVal(Math.round((1 - Math.pow(1 - p, 3)) * to));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [to, ms]);
  return val;
};

const Stat = ({ to, suffix, label }: { to: number; suffix: string; label: string }) => {
  const n = useCountUp(to);
  return (
    <div className="hb-stat">
      <b>{n}{suffix}</b>
      <small>{label}</small>
    </div>
  );
};

const HeroBanner = () => {
  const history = useHistory();
  const tiltRef = useRef<HTMLDivElement | null>(null);
  const [w, setW] = useState(0);

  // rotating word
  useEffect(() => {
    const t = setInterval(() => setW((i) => (i + 1) % WORDS.length), 2600);
    return () => clearInterval(t);
  }, []);

  // gentle 3D tilt
  const handleMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = tiltRef.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const ry = ((e.clientX - r.left) / r.width - 0.5) * 10;
    const rx = ((e.clientY - r.top) / r.height - 0.5) * -10;
    el.style.transform = `perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg)`;
  };
  const handleLeave = () => {
    if (tiltRef.current) tiltRef.current.style.transform = "perspective(1000px) rotateX(0deg) rotateY(0deg)";
  };

  return (
    <div className="hb gsapHomeBanner">
      <style>{STYLES}</style>

      <div className="hb-main">
        {/* TEXT */}
        <div className="hb-text">
          <div className="hb-chip"><i />ATUM Information Technology</div>

          <h1>
            Innovative Solutions to
            <span className="hb-rot"><span key={w}>{WORDS[w]}</span></span>
            Your Business Success
          </h1>

          <p className="hb-sub">
            Our innovative team is the driving force behind turning your ideas into
            impactful solutions that accelerate your business success and make the
            digital world more accessible.
          </p>

          <div className="hb-btns">
            <button className="hb-btn pri" onClick={() => history.push("/contact")}>
              Get Started <span>→</span>
            </button>
            <button className="hb-btn sec" onClick={() => history.push("/aboutUs")}>
              Learn More <span>→</span>
            </button>
          </div>

          <div className="hb-stats">
            <Stat to={50} suffix="+" label="Projects Delivered" />
            <Stat to={98} suffix="%" label="Client Satisfaction" />
            <Stat to={10} suffix="+" label="Years Experience" />
          </div>
        </div>

        {/* VISUAL */}
        <div className="hb-visual" onMouseMove={handleMove} onMouseLeave={handleLeave}>
          <div className="hb-tilt" ref={tiltRef}>
            <div className="hb-frame">
              <div className="hb-inner">
                <img src={homeBanner} alt="ATUM Information Technology" />
              </div>
            </div>

            <div className="hb-chipf c1">
              <span className="ico">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4.5 16.5c-1.5 1.3-2 5-2 5s3.7-.5 5-2c.7-.8.7-2.1-.1-2.9a2.2 2.2 0 00-2.9-.1z" />
                  <path d="M12 15l-3-3a22 22 0 012-3.95A12.9 12.9 0 0122 2c0 2.7-.8 7.5-6 11a22 22 0 01-4 2z" />
                  <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
                </svg>
              </span>
              <div><b>50+</b>Projects Done</div>
            </div>

            <div className="hb-chipf c2">
              <span className="ico">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1z" />
                </svg>
              </span>
              <div><b>98%</b>Satisfaction</div>
            </div>
          </div>
        </div>
      </div>

      {/* MARQUEE (list repeated so the loop is seamless) */}
      <div className="hb-marq">
        <div className="hb-track">
          {[0, 1].map((k) => (
            <span key={k}>
              {MARQUEE.map((m) => (
                <React.Fragment key={m + k}>
                  {m} <em>✦</em>
                </React.Fragment>
              ))}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;